<template>
    <v-navigation-drawer expand-on-hover rail floating class="mt-md-16">
        <v-list nav density="compact">
            <v-list-item :to="{name: 'emailTemplates'}">
                <template v-slot:prepend>
                    <v-icon>mdi-email</v-icon>
                </template>
                <v-list-item-title>{{ $t('admin.email_templates') }}</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{name: 'documentTemplates'}">
                <template v-slot:prepend>
                    <v-icon>mdi-file-pdf-box</v-icon>
                </template>
                <v-list-item-title>{{ $t('admin.document_templates') }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class AdminNavigation extends Vue {}

    export default AdminNavigation
</script>
